import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ItemsActions } from './items.actions';
import { ItemsSelectors } from './items.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {Item} from '@emm/core/models/item.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {SearchFilter} from '@emm/core/models/search-filter';


export interface ItemsQueries extends AsyncActionQueries {
    all$: Observable<Item[]>;
    selected$: Observable<Item>;
    initSize$: Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagementItemsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ItemsSelectors);
    }

    dispatch = {
        selectItem: (tag: string) =>
            this.store.dispatch(ItemsActions.select({ tag })),
        searchItems: (filter: SearchFilter) =>
            this.store.dispatch(ItemsActions.searchItems({ filter })),
        deleteItem: (item: Item) =>
            this.store.dispatch(ItemsActions.delete({ item })),
        toggleItemEnabled: (item: Item) =>
            this.store.dispatch(ItemsActions.toggleEnabled({ item }))
    };

    queries: ItemsQueries = {
        all$: this.selectNonNil(ItemsSelectors.getFilteredItems),
        selected$: this.selectNonNil(ItemsSelectors.getSelected),
        initSize$: this.select(ItemsSelectors.getInitSize),
        ...this.asyncActionQueries
    };

}
